// import API from "../../api";
import API from "../../services";
import {
  FETCH_BALANCE_SUCCESS,
  // FETCH_BALANCE_FAILED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  AUTH_REQUEST_START,
  AUTH_REQUEST_END,
  LOG_OUT,
  LOG_OUT_SUCCESS,
  MAIL_VERIFIED_REQUEST_SUCCESS,
  MAIL_VERIFIED_REQUEST_FAILED,
  SET_SAP_TOKEN,
  SET_OPERATOR_ID,
  SET_PARTNER_ID,
  SET_PROVIDER_ID,
  SET_JWT_TOKEN,
  SET_GRID_VIEW, SET_LOADER_SUCCESS,
  SET_LOBBY_TYPE,
} from "./authActionTypes";

// import SVLS_API from '../../api-services/svls-api';
// import axios from 'axios';

declare const sessionStorage: any;

export const requestStart = () => {
  return {
    type: AUTH_REQUEST_START,
  };
};

export const requestEnd = () => {
  return {
    type: AUTH_REQUEST_END,
  };
};

export const loginSuccess = (response) => {
  return {
    type: LOGIN_SUCCESS,
    payload: response,
  };
};

export const loginFailed = (err: string) => {
  return {
    type: LOGIN_FAILED,
    payload: err,
  };
};

const logoutSuccess = () => {
  return {
    type: LOG_OUT_SUCCESS,
  };
};

const logoutFailed = (err: string) => {
  return {
    type: LOG_OUT,
    payload: err,
  };
};

export const getRoleFromToken = (): string => {
  if (sessionStorage.getItem("jwt_token")) {
    const claim = sessionStorage.getItem("jwt_token").split(".")[1];
    return JSON.parse(window.atob(claim)).role;
  }
  return null;
};

export const getPermissionFromToken = () => {
  if (sessionStorage.getItem("jwt_token")) {
    const claim = sessionStorage.getItem("jwt_token").split(".")[1];
    return JSON.parse(window.atob(claim)).permission;
  }
  return null;
};

export const getCurrencyTypeFromToken = () => {
  if (sessionStorage.getItem("jwt_token")) {
    const claim = sessionStorage.getItem("jwt_token").split(".")[1];
    return JSON.parse(window.atob(claim)).currencyType;
  }
  return 0;
};

export const fetchMailVerifiedSuccess = (mailVerified: boolean) => {
  return {
    type: MAIL_VERIFIED_REQUEST_SUCCESS,
    payload: mailVerified,
  };
};

export const fetchMailVerifiedFailed = () => {
  return {
    type: MAIL_VERIFIED_REQUEST_FAILED,
    payload: null,
  };
};

export const logout = () => {
  const token = sessionStorage.getItem("jwt_token");
  return async (dispatch: Function) => { };
};

const fetchBalanceSuccess = (balance: number) => {
  return {
    type: FETCH_BALANCE_SUCCESS,
    payload: balance,
  };
};

// const fetchBalanceFailed = () => {
//   return {
//     type: FETCH_BALANCE_FAILED,
//   };
// };

const uniqueGuid = (): string => {
  const id = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    id() +
    id() +
    "-" +
    id() +
    "-" +
    id() +
    "-" +
    id() +
    "-" +
    id() +
    id() +
    id()
  );
};

export const fetchBalance = () => {
  return async (dispatch: Function) => {
    // try {
    //   const response = await API.get("/user/balance-summary", {
    //     headers: {
    //       Authorization: sessionStorage.getItem("jwt_token"),
    //     },
    //   });
    //   dispatch(fetchBalanceSuccess(response.data));
    // } catch (err) {
    //   // dispatch(fetchBalanceFailed());
    //   if (err.response && err.response.status === 401) {
    //     const token = sessionStorage.getItem("jwt_token");
    //     if (token) {
    //       dispatch(logout());
    //     }
    //   }
    // }
  };
};

export const loadColorConfig = () => {
  console.log("We are here doing something with colors!!!");
  return async (dispatch: Function) => {
    try {
      const response = await API.post("/load-color-config", {
        operatorId: sessionStorage.getItem("psOperatorId"),
        partnerId: sessionStorage.getItem("psPartnerId"),
        lobby: "premium",
        themeId: sessionStorage.getItem("themeId"),
      });
      response.data.primaryColor &&
        document.documentElement.style.setProperty(
          "--primary",
          `${response.data.primaryColor}`
        );
      response.data.background &&
        document.documentElement.style.setProperty(
          "--background",
          `${response.data.background}`
        );
      response.data.subHeaderColor &&
        document.documentElement.style.setProperty(
          "--sub-header-color",
          `${response.data.subHeaderColor}`
        );
      response.data.tableBackground &&
        document.documentElement.style.setProperty(
          "--table-bg",
          `${response.data.tableBackground}`
        );
      response.data.textColor &&
        document.documentElement.style.setProperty(
          "--text-color",
          `${response.data.textColor}`
        );
      response.data.tableHead &&
        document.documentElement.style.setProperty(
          "--table-head",
          `${response.data.tableHead}`
        );
      response.data.defaultColor &&
        document.documentElement.style.setProperty(
          "--odd-button-color",
          `${response.data.defaultColor}`
        );
      response.data.activeColor &&
        document.documentElement.style.setProperty(
          "--active-button-color",
          `${response.data.activeColor}`
        );
    } catch (err) { }
  };
};


export const setToken = (token: string) => {
  return {
    type: SET_JWT_TOKEN,
    payload: token,
  };
};

export const setLobby = (lobby: string) => {
  return {
    type: SET_LOBBY_TYPE,
    payload: lobby,
  };
};

export const setSapToken = (token: string) => {
  return {
    type: SET_SAP_TOKEN,
    payload: token,
  };
};

export const setOperatorId = (id: string) => {
  return {
    type: SET_OPERATOR_ID,
    payload: id,
  };
};

export const setPartnerId = (pid: string) => {
  return {
    type: SET_PARTNER_ID,
    payload: pid,
  };
};

export const setProviderId = (pid: string) => {
  return {
    type: SET_PROVIDER_ID,
    payload: pid,
  };
};

export const setLoading = (value: boolean) => {
  return {
    type: SET_LOADER_SUCCESS,
    payload: value,
  };
};

export const setGridView = (value: boolean) => {
  return {
    type: SET_GRID_VIEW,
    payload: value,
  };
};

export function setTextColor(hexColor) {
  var r = parseInt(hexColor.substring(1, 3), 16);
  var g = parseInt(hexColor.substring(3, 5), 16);
  var b = parseInt(hexColor.substring(5, 7), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 172 ? "dark-text" : "light-text";
}
